export default {
    "1": require('../assets/images/theme/default/emoji/demo/thumbs.png'),
    "2": require('../assets/images/theme/default/emoji/demo/angry.png'),
    "3": require('../assets/images/theme/default/emoji/demo/sad.png'),
    "4": require('../assets/images/theme/default/emoji/demo/laugh.png'),
    "5": require('../assets/images/theme/default/emoji/demo/amazed.png')
} as any